import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogToggleReplyCount from './VeltCommentDialogToggleReplyCount/VeltCommentDialogToggleReplyCount';
import VeltCommentDialogToggleReplyText from './VeltCommentDialogToggleReplyText/VeltCommentDialogToggleReplyText';
import VeltCommentDialogToggleReplyIcon from './VeltCommentDialogToggleReplyIcon/VeltCommentDialogToggleReplyIcon';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltCommentDialogToggleReply = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-toggle-reply-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogToggleReply.Icon = VeltCommentDialogToggleReplyIcon;
VeltCommentDialogToggleReply.Text = VeltCommentDialogToggleReplyText;
VeltCommentDialogToggleReply.Count = VeltCommentDialogToggleReplyCount;
export default VeltCommentDialogToggleReply;
